module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }